import Api from 'api';

import {
  GET_INS_OUTS_REPORT_CSV,
  GET_INS_OUTS_REPORT_PDF,
  GET_INS_OUTS_REPORT_PAGINATED,
  SET_INS_OUTS_REPORT_PAGINATION,
  SET_INS_OUTS_REPORT_FILTERS,
  RESET_INS_OUTS_REPORT,
} from 'reports/constants';

export const setInsOutsReportPagination = (payload) => ({
  type: SET_INS_OUTS_REPORT_PAGINATION,
  payload,
});

export const setInsOutsReportFilters = (payload) => ({
  type: SET_INS_OUTS_REPORT_FILTERS,
  payload,
});

export const getInsOutsReport = (
  companyId,
  subcompanyId,
  filters,
  limit,
  page,
  orderBy,
  order
) => ({
  type: GET_INS_OUTS_REPORT_PAGINATED,
  meta: { needAuth: true },
  payload: Api.reports.getHistoricsReportPaginated(
    companyId,
    subcompanyId,
    { ...filters, ins_outs: true },
    limit,
    page,
    orderBy,
    order
  ),
});

export const getInsOutsReportCSV = (companyId, subcompanyId, filters) => ({
  type: GET_INS_OUTS_REPORT_CSV,
  meta: { needAuth: true },
  payload: Api.reports.getInsOutsReportCSV(companyId, subcompanyId, filters),
});

export const getInsOutsReportPDF = (companyId, subcompanyId, filters) => ({
  type: GET_INS_OUTS_REPORT_CSV,
  meta: { needAuth: true },
  payload: Api.reports.getInsOutsReportArray(companyId, subcompanyId, filters),
});

export const resetInsOutsReport = () => ({
  type: RESET_INS_OUTS_REPORT,
});



// WEBPACK FOOTER //
// src/modules/secured/modules/reports/actions/ins_outs_report_actions.js